
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const WhoWeArePage = lazy(() => import('../pages/who-we-are/page'));
const WhatWeOfferPage = lazy(() => import('../pages/what-we-offer/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/who-we-are',
    element: <WhoWeArePage />,
  },
  {
    path: '/what-we-offer',
    element: <WhatWeOfferPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
